import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '../../interfaces/user.interface';
import { PMEUserService } from '../services/pme-user.service';

@Pipe({
  name: 'canApprove',
  standalone: true
})
export class CanApprovePipe implements PipeTransform {
  constructor(private pmeUserService: PMEUserService) {}

  // biome-ignore lint/suspicious/noExplicitAny: Allowing as currentItem could be many different types
  transform(currentItem: any): boolean {
    const currentUser = this.pmeUserService.currentUser;

    return (
      (!currentItem['status'] || currentItem['status'] === 'active') &&
      ((!currentItem['verified'] &&
        !currentItem['approved'] &&
        currentUser?.roles?.includes(UserRole.PMEDataIntegrity)) ??
        false)
    );
  }
}
